import Badge, { BadgeTone } from '../../../components/badges/Badge'
import { Role } from '../types'

// Ink ramp: Admin (most power) is the solid chip, Member mid, Viewer (read-only)
// lightest. Neutral so red stays reserved for actions.
const TONES: Record<Role, BadgeTone> = {
    Admin: 'wireframeSolid',
    Member: 'wireframeMuted',
    Viewer: 'wireframeFaint'
}

// Inline role selector look (non-functional caret) used in the RBAC table.
export default function RoleBadge({ role }: { role: Role }) {
    return (
        <Badge tone={TONES[role]} shape="rounded" size="medium" weight="semibold">
            {role}
            {/* Spaced with a margin rather than a gap on the badge, so Badge needs no
                gap axis for the one component that has two children. */}
            <span className="ml-1.5 text-[9px] opacity-60">▾</span>
        </Badge>
    )
}
